import { FaRegCheckCircle } from "react-icons/fa";
import "../styles/art-page.css";

const sessions = [
  {
    title: "Buổi 1: Làm quen với hình – màu – chất liệu",
    content: [
      "Giới thiệu các hình cơ bản (tròn, vuông, tam giác...)",
      "Khám phá bảng màu cơ bản: màu nóng – màu lạnh",
      "Thực hành: vẽ hình khối và tô màu tự chọn",
    ],
  },
  {
    title: "Buổi 2: Màu sắc cảm xúc",
    content: [
      "Cảm xúc và màu sắc liên kết thế nào?",
      'Trò chơi: "Tôi cảm thấy màu gì hôm nay?"',
      'Thực hành: Vẽ tranh "Một ngày cảm xúc của em"',
    ],
  },
  {
    title: "Buổi 3: Vẽ tĩnh vật đơn giản",
    content: [
      "Học quan sát: quả táo, bình hoa, đồ chơi...",
      "Giới thiệu bố cục – ánh sáng – kích thước",
      "Thực hành: Vẽ một vật yêu thích bằng bút chì màu",
    ],
  },
  {
    title: "Buổi 4: Thế giới động vật",
    content: [
      "Cách đơn giản hóa hình dáng động vật",
      "Quan sát và vẽ mèo, cá, chim... từ hình cơ bản",
      "Vẽ tranh “Thú cưng em yêu” bằng màu nước",
    ],
  },
  {
    title: "Buổi 5: Kỹ thuật xé dán sáng tạo",
    content: [
      "Học cách xé giấy – phối hợp màu và hình khối",
      "Thực hành: Làm tranh xé dán về “Khu vườn mơ ước”",
    ],
  },
  {
    title: "Buổi 6: Sáng tạo từ vân tay – chấm tròn",
    content: [
      "Tạo nhân vật từ dấu vân tay",
      "Kết hợp kỹ thuật chấm tròn (pointillism)",
      "Làm tranh “Khu rừng kỳ lạ”",
    ],
  },
  {
    title: "Buổi 7: Vẽ gương mặt & biểu cảm",
    content: [
      "Các bước đơn giản để vẽ khuôn mặt",
      "Thực hành: Vẽ chân dung bạn bè và tô màu",
      "Trò chơi biểu cảm: “Vui – buồn – bất ngờ – giận dỗi”",
    ],
  },
  {
    title: "Buổi 8: Thế giới tưởng tượng – không giới hạn",
    content: [
      "Hướng dẫn phát triển ý tưởng từ trí tưởng tượng",
      "Vẽ tranh “Ngôi nhà bay” – “Con vật kỳ lạ”",
      "Tự do kết hợp hình khối – màu sắc – họa tiết",
    ],
  },
  {
    title: "Buổi 9: Tạo họa tiết từ thiên nhiên",
    content: [
      "Quan sát lá cây, vỏ ốc, vân gỗ...",
      "In dấu lá, họa tiết lặp lại",
      'Làm tranh "Thảm rừng họa tiết"',
    ],
  },
  {
    title: "Buổi 10: Vẽ theo nhạc",
    content: [
      "Nghe nhạc – cảm nhận nhịp điệu",
      "Dùng màu và đường nét để thể hiện giai điệu",
      'Thực hành tranh "Bản nhạc sắc màu"',
    ],
  },
  {
    title: "Buổi 11: Làm đồ thủ công (mask – đồ treo tường)",
    content: [
      "Tạo mặt nạ từ giấy/carton",
      "Tự do trang trí bằng màu, lông vũ, cúc áo...",
      "Làm móc treo hình thú ngộ nghĩnh",
    ],
  },
  {
    title: "Buổi 12: Nghệ thuật tái chế",
    content: [
      "Thu gom vật liệu cũ: vỏ chai, giấy báo, hộp giấy...",
      "Thực hành làm tranh 3D hoặc đồ vật trang trí",
      "Giáo dục môi trường lồng ghép trong mỹ thuật",
    ],
  },
  {
    title: "Buổi 13: Hoàn thiện sản phẩm cá nhân",
    content: [
      "Mỗi bé chọn 1 sản phẩm để vẽ/tạo lại chỉn chu hơn",
      "Có thể tự chọn kỹ thuật: vẽ, xé dán, thủ công...",
    ],
  },
  {
    title: "Buổi 14: Chuẩn bị triển lãm mini",
    content: [
      "Gắn tên, thuyết minh tranh",
      "Hướng dẫn cách thuyết trình sản phẩm",
      "Tập dượt giới thiệu tranh cho phụ huynh",
    ],
  },
  {
    title: "Buổi 15: Triển lãm và tổng kết",
    content: [
      "Triển lãm tranh tại lớp (mời phụ huynh tham dự)",
      "Thuyết trình sản phẩm yêu thích",
      "Trao giấy chứng nhận + phần thưởng sáng tạo",
      "Ghi nhận cảm xúc cuối khóa",
    ],
  },
];

const ArtPage = () => {
  return (
    <div className="art-page-bg">
      <div className="art-page">
        <div className="art-page__intro">
          <h1 className="art-page__title">Sáng tạo Mỹ thuật cho Thiếu nhi</h1>
          <p className="art-page__desc">
            Chương trình phát triển khả năng quan sát, óc tưởng tượng và tư duy
            nghệ thuật cho học sinh cấp 1 và cấp 2. Trẻ được tiếp cận đa dạng
            chất liệu mỹ thuật qua 15 buổi học sinh động, kết thúc bằng triển
            lãm cá nhân.
          </p>
          <p className="art-page__meta">
            <strong>Thời lượng:</strong> 15 buổi (mỗi buổi 2 giờ) |{" "}
            <strong>Đối tượng:</strong> Học sinh cấp 1 & 2
          </p>
        </div>
        <div className="art-page__extras">
          <h3 className="art-page__extras-title">Mục tiêu khóa học</h3>
          <ul className="art-page__extras-list">
            <li>
              <span className="emoji">🎨</span> Làm quen với nền tảng hội họa và
              kỹ năng quan sát
            </li>
            <li>
              <span className="emoji">💡</span> Khơi gợi óc tưởng tượng, sáng
              tạo cá nhân
            </li>
            <li>
              <span className="emoji">🖌️</span> Thực hành nhiều chất liệu và thể
              loại mỹ thuật
            </li>
            <li>
              <span className="emoji">🏆</span> Tạo ra sản phẩm cá nhân và triển
              lãm cuối khóa
            </li>
          </ul>
        </div>
        <h2 className="art-page__section-title">Lộ trình khóa học</h2>
        <div className="art-page__sessions">
          {sessions.map((session, idx) => (
            <div
              className="art-page__session"
              key={idx}
            >
              <h3 className="art-page__session-title">{session.title}</h3>
              <ul className="art-page__session-list">
                {session.content.map((item, i) => (
                  <li
                    className="art-page__session-item"
                    key={i}
                  >
                    <FaRegCheckCircle className="art-page__icon" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ArtPage;
